import { render } from "./DicomPage.vue?vue&type=template&id=789e7902"
import script from "./DicomPage.vue?vue&type=script&lang=js"
export * from "./DicomPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__